// removed by extract-text-webpack-plugin
module.exports = {"versionInfoRoot":"versionInfoRoot--52242","versionInfoVersionNumber":"versionInfoVersionNumber--27020"};